var SuggestionItemType = /* @__PURE__ */ function(SuggestionItemType2) {
  SuggestionItemType2["TAG"] = "tag";
  SuggestionItemType2["FOLDER"] = "folder";
  return SuggestionItemType2;
}(SuggestionItemType || {});

export { SuggestionItemType };
//# sourceMappingURL=magic.types.js.map
